import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  width: 100%;
  gap: 1rem;
`;

export const ButtonDiv = styled.div`
  width: 100%;
`;
